module.exports = __webpack_public_path__ + "static/img/1.06b3286.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/sp/1.png
// module id = HV9+
// module chunks = 0